import { Component, Input } from '@angular/core';


@Component({
	selector: 'bb-technical-info',
	templateUrl: './bb-technical-info.component.html',
	styleUrls: ['./bb-technical-info.component.scss']
})

export class BbTechnicalInfoComponent {
	@Input() technicalInfo: { tracks?: any[] };
}
